import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const SpecialistsPage = lazy(() => import('./pages/Specialists'));
const BookPage = lazy(() => import('./pages/Book'));
const CheckoutPage = lazy(() => import('./pages/Checkout'));
const MyAppointmentsPage = lazy(() => import('./pages/MyAppointments'));
const ReschedulePage = lazy(() => import('./pages/Reschedule'));

const patient = (el: React.ReactNode) => <RequireAuth registered>{el}</RequireAuth>;

/** Consulta privada do paciente (F-04): diretório, ponte de agendamento, checkout (T-19), minhas consultas e reagendamento (T-20). */
const routes: RouteObject[] = [
  { path: '/especialistas', element: <SpecialistsPage /> },
  { path: '/agendar/:subdominio', element: <BookPage /> },
  { path: '/consultas', element: patient(<MyAppointmentsPage />) },
  { path: '/consultas/:id/pagamento', element: patient(<CheckoutPage />) },
  { path: '/consultas/:id/reagendar', element: patient(<ReschedulePage />) },
];
export default routes;
